// @flow
import { Colors } from '@zapier/theme';

const FilterRulEditorStyles = {
  root: {
    marginTop: '10px',
  },
  deleteButton: {
    alignItems: 'center',
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.adamantium}`,
    borderRadius: '3px',
    color: Colors.steel,
    display: 'flex',
    justifyContent: 'center',
    padding: '13px',
    width: '45px',
    '&:hover': {
      color: Colors.lava,
      cursor: 'pointer',
    },
  },
};

export default FilterRulEditorStyles;
